module.exports = __webpack_public_path__ + "static/img/1.8de2131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Todo-riesgo-empresarial/1.png
// module id = U8Ed
// module chunks = 0